class TokenManager {
  /**
   *
   * @param {Array} tokens
   */
  constructor(tokens) {
    this.tokens = tokens.map((t) => ({
      type: "token",
      start: t[0],
      end: t[1],
      text: t[2],
    }));
    this.words = tokens.map(t => t[2]); 
  }

  /**
   * Creates a new token block with the tokens whose starts match the input
   * parameters
   *
   * @param {Number} start 'start' value of the token forming the start of the token block
   * @param {Number} end 'start' value of the token forming the end of the token block
   * @param {Number} _class the id of the class to highlight
   */
  addNewBlock(_start, _end, _class) {
    let selectedTokens = [];
    let newTokens = [];

    let start = _end < _start ? _end : _start;
    let end = _end > _start ? _end : _start;
    
    for (let i = 0; i < this.tokens.length; i++) {
      let t = this.tokens[i];
      if (t.start < start) {
        newTokens.push(t);
      } else if (t.type == "token" && t.start >= start && t.start <= end) {
        selectedTokens.push(t);
      } else if (t.start > start && selectedTokens.length) {
        newTokens.push({
          type: "token-block",
          start: selectedTokens[0].start,
          end: selectedTokens[selectedTokens.length - 1].end,
          tokens: selectedTokens,
          label: _class && _class.name ? _class.name : "Unlabelled",
          classId: _class && _class.id ? _class.id : 0,
          backgroundColor: _class && _class.color ? _class.color : null,
          person: "藤原光俊",
          role: "役職名",
        });
        selectedTokens = [];
        newTokens.push(t);
      } else {
        newTokens.push(t);
      }
    }

    // Case if the selected tokens are at the end of the text and have not been added to the newTokens
    if (selectedTokens.length) {
        newTokens.push({
          type: "token-block",
          start: selectedTokens[0].start,
          end: selectedTokens[selectedTokens.length - 1].end,
          tokens: selectedTokens,
          label: _class && _class.name ? _class.name : "Unlabelled",
          classId: _class && _class.id ? _class.id : 0,
          backgroundColor: _class && _class.color ? _class.color : null,
          person: "藤原光俊",
          role: selectedTokens[0].start,
      });
    }

    this.tokens = newTokens;
  }

  addNewRoleBlock(_start, _end, _class, _person, _role) {
    let selectedTokens = [];
    let newTokens = [];

    let start = _end < _start ? _end : _start;
    let end = _end > _start ? _end : _start;
    
    for (let i = 0; i < this.tokens.length; i++) {
      let t = this.tokens[i];
      if (t.start < start) {
        newTokens.push(t);
      } else if (t.type == "token" && t.start >= start && t.start <= end) {
        selectedTokens.push(t);
      } else if (t.start > start && selectedTokens.length) {
        newTokens.push({
          type: "token-block",
          start: selectedTokens[0].start,
          end: selectedTokens[selectedTokens.length - 1].end,
          tokens: selectedTokens,
          label: _class && _class.name ? _class.name : "Unlabelled",
          classId: _class && _class.id ? _class.id : 0,
          backgroundColor: _class && _class.color ? _class.color : null,
          person: _person,
          role: _role,
        });
        selectedTokens = [];
        newTokens.push(t);
      } else {
        newTokens.push(t);
      }
    }

    // Case if the selected tokens are at the end of the text and have not been added to the newTokens
    if (selectedTokens.length) {
        newTokens.push({
          type: "token-block",
          start: selectedTokens[0].start,
          end: selectedTokens[selectedTokens.length - 1].end,
          tokens: selectedTokens,
          label: _class && _class.name ? _class.name : "Unlabelled",
          classId: _class && _class.id ? _class.id : 0,
          backgroundColor: _class && _class.color ? _class.color : null,
          person: _person,
          role: _role,
      });
    }

    this.tokens = newTokens;
  }
  /**
   * Removes a token block and puts back all the tokens in their original position
   *
   * @param {Number} blockStart 'start' value of the token block to remove
   */
  removeBlock(blockStart) {
    let newTokens = [];
    for (let i = 0; i < this.tokens.length; i++) {
      if (
        this.tokens[i].type === "token-block" &&
        this.tokens[i].start === blockStart
      ) {
        newTokens.push(...this.tokens[i].tokens);
      } else {
        newTokens.push(this.tokens[i]);
      }
    }
    this.tokens = newTokens;
  }

  /**
   * Removes all the tag blocks and leaves only tokens
   */
  resetBlocks() {
    let newTokens = [];
    for (let i = 0; i < this.tokens.length; i++) {
      if (this.tokens[i].type === "token") {
        newTokens.push(this.tokens[i]);
      } else {
        newTokens.push(...this.tokens[i].tokens);
      }
    }
    this.tokens = newTokens;
  }

  /**
   * Exports the tokens and the token blocks as annotations
   */
  exportAsAnnotation() {
    let entities = [];
    for (let i = 0; i < this.tokens.length; i++) {
      if (this.tokens[i].type === "token-block") {
        let b = this.tokens[i];
        if (b.label == "語句") {
          entities.push([b.start, b.end, b.label]);
        } else {
          entities.push([b.start, b.end, b.label, b.person, b.role]);
        }
      }
    }
    return entities;
  }
}

export default TokenManager;
